var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TextImage',{attrs:{"id":_vm.anchorName,"alignment":_vm.alignment,"caption":_vm.caption,"headline":_vm.headline,"intro-text":_vm.introText,"media":_vm.media,"display-dekra-shield":_vm.displayDekraShield,"type":_vm.mediaType,"content":_vm.content,"toggle-gap":_vm.toggleGap}})
}
var staticRenderFns = []

export { render, staticRenderFns }